import script from "./LoginCode.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginCode.vue?vue&type=script&setup=true&lang=js"

import "./LoginCode.vue?vue&type=style&index=0&id=6ff7bdea&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ff7bdea"]])

export default __exports__